import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useRoasStore } from '@/stores/roas'

const SummaryModeSelect = () => {
  const summaryMode = useRoasStore((state) => state.summaryMode)
  const setSummaryMode = useRoasStore((state) => state.setSummaryMode)

  return (
    <Select value={summaryMode} onValueChange={setSummaryMode}>
      <SelectTrigger className="w-[120px]">
        <SelectValue placeholder="Mode" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="daily">Daily</SelectItem>
        <SelectItem value="weekly">Weekly</SelectItem>
        <SelectItem value="monthly">Monthly</SelectItem>
      </SelectContent>
    </Select>
  )
}

export default SummaryModeSelect
